import 'phaser'
import $ from 'jquery'
import {
    CST
} from '../CST'
import BubblesScene from './Bubbles';

var User_ID = Math.floor((Math.random() * 9999999) + 1);

export default class Menu extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.MENU);
    }

    preload() {}

    create() {
        this.clickSound = this.sound.add("click-sound");
        this.scene.remove(CST.SCENES.BUBBLES);
        this.scene.add(CST.SCENES.BUBBLES, BubblesScene, false);

        this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'menu-bg');
        sendUserDataToDatabase();
        this.add.image(this.cameras.main.width / 2 - 250, (this.cameras.main.height / 2) + 370, 'bubble-button').setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            this.clickSound.play();
            this.scene.start(CST.SCENES.BUBBLESINTRO, {
                User_ID: User_ID
            });
        })

        this.add.image(this.cameras.main.width / 2 + 250, (this.cameras.main.height / 2) + 370, 'questionnaire-button').setInteractive({
            useHandCursor: true
        }).on("pointerdown", () => {
            this.clickSound.play();
            this.scene.start(CST.SCENES.QUIZ, {
                User_ID: User_ID
            });
        })
    }
}

function sendUserDataToDatabase() {
    var userData = {
        "User_ID": User_ID,
    }

    //Sending JSON string to PHP file
    $.ajax({
        type: 'POST',
        url: 'website/post-user-to-ddbb.php',
        dataType: 'JSON',
        data: userData,
    }).responseJSON;
}